import { useSelector } from 'react-redux';

import { bedsTitleSelector } from 'reducers/filters';

export const useSelectBedsTitle = () => useSelector(bedsTitleSelector);
